
export default {
  steps: {
    instruction: 'Anweisung',
    on: 'Auf',
    step: 'Schritt',
    gotoStep: 'Gehe zu Schritt'
  }
}
